import types from "../types";
import { copy, Notification, url_encode } from "../../utils";
import { global_actions } from "../";
import backend from "../../api";

const create_product = (prod) => async (dispatch) => {
  const status = new Notification();
  dispatch(global_actions.loading(true));
  try {
    const {
      data: { data, message },
    } = await backend.post("/product", prod, {
      params: {
        populate: url_encode([
          { path: "merchant_user", select: "-password" },
          { path: "product_category" },
        ]),
      },
    });
    status.set_toast("success", message);

    dispatch(
      fetch_products({ merchant_user: prod?.merchant_user, published: true })
    );
  } catch (error) {
    status.set_toast(
      "error",
      error.response ? error.response.data.message : error.message
    );
  } finally {
    dispatch(global_actions.loading(false));
    status.show_toast();
  }
};

const fetch_products = (
  query = { published: true, page: 1, limit: 10, member_user: "" }
) => async (dispatch, getState) => {
  const state = copy(getState().products);
  const status = new Notification();
  dispatch(global_actions.loading(true));
  try {
    const { data } = await backend.get("/product", {
      params: {
        ...query,
        populate: url_encode([
          { path: "merchant_user", select: "-password" },
          { path: "product_category" },
        ]),
      },
    });
    console.log("Fetched products data:", data);

    const uniqueProducts = data.data.filter(
      (product, index, self) =>
        index === self.findIndex((p) => p._id === product._id)
    );

    state.data = uniqueProducts;
    state.total = data.totalDocs; 
  } catch (error) {
    status.set_toast(
      "error",
      error.response ? error.response.data.message : error.message
    );
  } finally {
    dispatch({
      type: types.PRODUCT,
      payload: state,
    });
    dispatch(global_actions.loading(false));
    status.show_toast();
  }
};

const update_product = (prod) => async (dispatch, getState) => {
  const state = copy(getState().products);
  const status = new Notification();
  dispatch(global_actions.loading(true));

  try {
    const {
      data: { data, message },
    } = await backend.put(
      `/product/${prod._id}`,
      { ...prod, date_updated: new Date(), _id: undefined },
      {
        params: {
          populate: url_encode([
            { path: "merchant_user", select: "-password" },
            { path: "product_category" },
          ]),
        },
      }
    );
    state.data = state.data.map((i) => (i._id === prod._id ? data : i));
    status.set_toast("success", message);
  } catch (error) {
    status.set_toast(
      "error",
      error.response ? error.response.data.message : error.message
    );
  } finally {
    dispatch({
      type: types.PRODUCT,
      payload: state,
    });
    dispatch(global_actions.loading(false));
    status.show_toast();
  }
};

const update_filter = (filters) => (dispatch, getState) => {
  const state = copy(getState().products);
  state.filters = filters;
  dispatch({
    type: types.PRODUCT,
    payload: state,
  });
  dispatch(fetch_products(filters));
};

export default {
  fetch_products,
  update_filter,
  create_product,
  update_product,
};
